import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: start;
  gap: 8px;
`;

export const CatalogItemName = styled.h1`
  margin: 0;
  padding: 0;
  font-size: 22px;
  line-height: 32px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.common.TEXTS};
`;
